import { atom } from "jotai";

export const sizeChartAtom = atom(false);
